import { useDialogClose } from '../hooks/useDialogClose';

interface DeleteChatDialogProps {
  isGroupChat: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function DeleteChatDialog({ isGroupChat, onConfirm, onCancel }: DeleteChatDialogProps) {
  const { isClosing, handleClose } = useDialogClose(onCancel);

  return (
    <div className={`delete-dialog-overlay${isClosing ? ' overlay-closing' : ''}`} onClick={handleClose}>
      <div className={`delete-dialog${isClosing ? ' dialog-closing' : ''}`} onClick={(e) => e.stopPropagation()}>
        <div className="delete-dialog-title">Delete this chat?</div>
        <div className="delete-dialog-text">
          {isGroupChat
            ? 'You will leave this group chat and it will be removed from your sidebar.'
            : 'This chat will be removed from your sidebar.'}
        </div>
        <div className="delete-dialog-actions">
          <button className="btn-ghost" type="button" onClick={handleClose}>Cancel</button>
          <button className="btn-danger" type="button" onClick={onConfirm}>Delete</button>
        </div>
      </div>
    </div>
  );
}
